<template>
  <navigation-menu-item target-path="account-settings" title="הגדרות מנוי" v-on:navigate="$emit('navigate')" :icon="icon"/>
</template>

<script>
import { mapState } from 'vuex';
import NavigationMenuItem from './NavigationMenuItem.vue';
import { SUBSCRIPTION_STATES } from '../../constants/subscription-state';

export default {
  name: 'AccountSettingsMenuItem',
  components: { NavigationMenuItem },
  computed: {
    ...mapState('promotions', ['eligibleForDiscountPromotion']),
    ...mapState('subscriptionState', ['subscriptionState']),
    showDiscountPromotionIcon() {
      const eligibleSubscriptionState = _.includes([SUBSCRIPTION_STATES.TRIAL, SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL], this.subscriptionState);
      return this.eligibleForDiscountPromotion && eligibleSubscriptionState;
    },
    icon() {
      return this.showDiscountPromotionIcon ? 'discount-benefit.svg' : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/base-components/app-header/AccountSettingsMenuItem.vue